<template>
	<v-form @submit.prevent="login">
		<v-text-field
			:label="$t('login.mobile_or_email')"
			type="text"
			prepend-icon="mdi-email"
			v-model="form.email"
			:error-messages="errors.email"
			id="login-form-email"
		/>
		<v-text-field
			:label="$t('login.password')"
			type="password"
			prepend-icon="mdi-lock"
			v-model="form.password"
			:error-messages="errors.password"
			id="login-form-pass"
		/>
		<v-btn color="primary" block size="large" @click="login">
			{{ $t('login.confirm') }}
		</v-btn>
		<template v-if="ssoEnabled">
			<div class="text-center text-caption text-medium-emphasis my-3">或</div>
			<v-btn color="secondary" variant="tonal" block size="large" @click="ssoLogin">
				使用无所咖啡账号登录
			</v-btn>
		</template>
	</v-form>
</template>

<script>
export default {
	data() {
		return {
			form: {
				email: '',
				password: '',
				captchainput: '',
				redirect: '/'
			},
			errors: {}
		}
	},
	computed: {
		ssoEnabled() {
			const sso = this.$soul?.sso
			return !!(sso && sso.enabled !== false && sso.authorizeUrl && sso.clientId)
		}
	},
	methods: {
		login() {
			this.$api.auth.login(
				this.form,
				(res) => {
					this.$emit('success', res)
					this.form = {
						email: '',
						password: '',
						captchainput: '',
						redirect: '/'
					}
				},
				(err) => {
					this.$emit('error', err)
					this.errors = err.message
				}
			)
		},
		ssoLogin() {
			const sso = this.$soul.sso
			const redirectUri = `${window.location.origin}/sso/callback`
			const url = new URL(sso.authorizeUrl)
			url.searchParams.set('client_id', sso.clientId)
			url.searchParams.set('redirect_uri', redirectUri)
			window.location.href = url.toString()
		}
	}
}
</script>
